module.exports = __webpack_public_path__ + "img/KX.7686e823.png";